
export const experiences = [
    {
      date: "Nov 2025 – ",
      role: "Full-Stack Developer",
      company: "Ideal Software Solutions",
      details: [
        "Developed and delivered multiple client websites/web Apps using React.js, NodeJs, and modern technologies, ensuring responsive & scalable solutions.",
        "Collaborated with clients/stakeholders to gather requirements and translate business needs into technical implementations.",
        "Built and optimized frontend interfaces and backend APIs and enhancing overall user experience.",
        "Debugged and resolved production issues, reducing post-deployment bugs.",
      ],
      tech: ["JavaScript", "React", "NodeJS", "TypeScript", "Next.js", "NestJS", "HTML", "CSS", "Tailwind", "SQL",  "MongoDB", "Markdown"],
    },
    {
      date: "Apr 2024 – ",
      role: "Full-Stack AI Trainer (Part-Time)",
      company: "Outlier",
      details: [
        "Reviewed and assessed AI-generated code in JavaScript, React, and other frameworks for accuracy and best practices.",
        "Created and answered questions related to front-end development and web design to aid AI training.",
        "Evaluated UI/UX quality, accessibility, and design choices in AI-generated outputs.",
        "Provided expert feedback to enhance the intuitiveness and functionality of user interfaces.",
      ],
      tech: ["JavaScript", "React", "NodeJS", "Python", "TypeScript", "HTML", "CSS", "Tailwind", "Markdown"],
    },
    {
      date: "Dec 2024 – Jan 2025",
      role: "Full-Stack Developer",
      company: "LeanLearn",
      details: [
        "Developed client, portal, and admin websites from concept to launch within a 1-month period, ensuring a cohesive and responsive design.",
        "Collaborated with cross-functional teams to align website functionality with business goals and user needs."
      ],
      tech: ["JavaScript", "NodeJS", "React", "TypeScript", "SQL", "Supabase"],
    },
    {
      date: "Oct 2024 – Dec 2024",
      role: "Research & Development Intern",
      company: "EncryptaIn",
      details: [
        "Most of internship work revolved around Full-Stack development",
        "Developed an Event Schedular feature for the Encrypta workspace calander and fixed many bugs and resolved many issues within",
        "Improved code quality and application efficiency by implementing best practices."
      ],
      tech: ["JavaScript", "NodeJS", "Python", "TypeScript", "React"]
    },
    {
      date: "Nov 2022 – Nov 2025",
      role: "Research Consultant (Part Time)",
      company: "WorldQuant",
      details: [
        "Automated alpha simulations with JavaScript and SQL, reducing testing time by over 90%.",
        "Integrated BRAIN APIs with NodeJS scripts for automated alpha creation, utilizing MongoDB as the data store.",
        "Mentored 20+ students at IITM to become a Research consultant at WordQuant.",
      ],
      tech: ["JavaScript", "NodeJs", "Python", "MongoDB", "SQL", "SQLite" ]
    },
    
  ];
